// Public entry gateways only. Never accept arbitrary redirect URLs.
function validAuthReturn(value) {
  if (typeof value !== 'string') return null;
  if (/^\/auth\/complete\?request=[A-Za-z0-9_-]{43}$/.test(value)) return value;
  if (/^\/oauth\/resume\?request=[a-f0-9]{64}$/.test(value)) return value;
  if (/^\/client\/plugin-connect\?request=[A-Za-z0-9_-]{43}$/.test(value)) return value;
  if (/^\/client\/connect\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(value)) return value;
  if (/^\/brief\?client=(lovable|bolt|v0|replit)$/.test(value)) return value;
  return ['/docs/install-pabs', '/brief', '/brief?entry=app', '/account'].includes(value) ? value : null;
}
module.exports = {validAuthReturn};
